<template>
    <x-modal :title="title"
             :visible="showDialog"
             @open="handleOpen"
             @close="clickClose"
             width="600px">
        <div class="row">
            <div class="col-12">
                <div class="row">
                    <div class="col-12" style="font-weight: bold; margin-bottom: 8px">Descargas</div>
                    <div class="col" style="display: flex; justify-content: center">
                        <x-button-pdf label="A4"
                                      color="btn-info"
                                      icon="fa-light fa-download"
                                      @click="clickDownload('a4', 'pdf')"></x-button-pdf>
                    </div>
                </div>
            </div>
            <div class="col-md-12 btn-actions">
                <x-button-cancel @click="clickClose" text="Cerrar"></x-button-cancel>
            </div>
        </div>
    </x-modal>
</template>

<script>

import XInput from "../../../../components/Form/XInput.vue"
import XModal from "../../../../components/XModal.vue"
import XButtonCancel from "../../../../components/Form/XButtonCancel.vue"
import XButtonSubmit from "../../../../components/Form/XButtonSubmit.vue"
import XButtonPdf from "../../../../components/XButtonPdf.vue";

export default {
    name: 'TransferWarehouseFinish',
    components: {XButtonPdf, XButtonSubmit, XButtonCancel, XModal, XInput},
    props: [
        'showDialog',
        'record'
    ],
    data() {
        return {
            loading: false,
            resource: 'inventory_transfer',
            title: '',
            errors: {},
            form: {},
        };
    },
    created() {
        this.initForm()
    },
    methods: {
        initForm() {
            this.title = ''
            this.errors = {}
            this.form = {}
        },
        handleOpen() {
            this.initForm()
        },
        clickClose() {
            this.$emit("update:showDialog", false)
        },
        clickToPrint(format) {
            window.open(`/${this.resource}/print/${this.record.external_id}`, '_blank');
        },
        clickDownload(format, type) {
            window.open(`/${this.resource}/download/${this.record.external_id}`, '_blank');
        },
    },
};
</script>
